import React from 'react';
import { Link } from '../Link.jsx';
import AuthorizedAction from '../AuthorizedAction.js';
import { getOrgSlug } from '../../lib/utils.js';

export const UserLink = ({ userId, ...props }) => (
  <Link
    route="organization/users/show"
    params={{ userId, slug: getOrgSlug() }}
    {...props}
  />
);

export const NewUserLink = ({ ...props }) => (
  <AuthorizedAction action="create" subject="user">
    <Link
      route="organization/users/new"
      params={{ slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const EditUserLink = ({ userId, ...props }) => (
  <AuthorizedAction action="update" subject="user">
    <Link
      route="organization/users/edit"
      params={{ userId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const AddRoleLink = ({ userId, ...props }) => (
  <AuthorizedAction action="create" subject="userProjectRole">
    <Link
      route="organization/users/permissions/new"
      params={{ userId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const EditRoleLink = ({ userId, projectId, ...props }) => (
  <Link // Link with outer authorization check
    route="organization/users/permissions/edit"
    params={{
      slug: getOrgSlug(),
      userId,
      projectId,
    }}
    {...props}
  />
);

export const PermissionsLink = ({ userId, ...props }) => (
  <AuthorizedAction action="read" subject="userProjectRole">
    <Link
      route="organization/users/permissions/show"
      params={{ userId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);
